import { CreateCompanyInvitationDTOPlanEnum } from '../api-client/generated';

/* eslint-disable import/prefer-default-export */
export const planOptions = [
  CreateCompanyInvitationDTOPlanEnum.Calculator,
  CreateCompanyInvitationDTOPlanEnum.Premium
];

export type planEnum = CreateCompanyInvitationDTOPlanEnum;
